<template>
  <b-taginput ref="input" :on-paste-separators="[]" :confirm-keys="['Tab', 'Enter']" v-bind="tagInputProps" :placeholder="placeholder" v-model="model" :data="filteredData"  @remove="resetAutocomplete" @typing="filterData" @add="resetAutocomplete">
    <template v-for="(_, slot) of $slots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
    <template #empty>
      <slot name="all-selected" v-if="Array.isArray(model) && model.length == data.length && model.length > 0"></slot>
      <slot name="not-found" v-else></slot>
    </template>
  </b-taginput>
</template>

<script>
import {toRaw} from "vue";

export default {
  name: "LdTaginput",
  props: {
    modelValue: {
      type: [String, Number, Array]
    },
    data: {
      type: Array,
      default: () => { return []; }
    },
    inputProps: {
      type: Object,
      default: () => { return {} }
    },
    nestedObjectKey: {
      type: String,
      required: false,
      default: ''
    }
  },
  emits: ['update:modelValue', 'filtered-data'],
  watch: {
    model() {
      this.$emit('update:modelValue', this.model)

      if (Array.isArray(this.model)) {
        if (this.model.length == 0) {
          this.placeholder = this.inputProps['placeholder']
        } else {
          this.placeholder = ''
        }
      }
    },
    data: {
      handler() {
        this.filteredData = this.data
        this.filterDuplicates()
      },
      immediate: true
    },
    modelValue: {
      handler() {
        this.model = this.modelValue
        this.filterDuplicates()
      },
      immediate: true
    }
  },
  computed: {
    tagInputProps() {
      return { ...{autocomplete: true, openOnFocus: true, type: 'is-info'}, ...this.inputProps}
    }
  },
  methods: {
    resetAutocomplete() {
      this.filteredData = this.data
      this.filterDuplicates()
    },
    filterData(val) {
      const field = this.inputProps.field || 'name'
      this.filteredData = this.data.filter(x => {
        let filterTarget = x[field]
        if (this.nestedObjectKey) {
          filterTarget = x[this.nestedObjectKey][field]
        }
        return filterTarget.toLowerCase().indexOf(val.toLowerCase()) !== -1
      })
      this.filterDuplicates()
      this.$emit('filtered-data', this.filteredData)
    },
    filterDuplicates() {
      if (Array.isArray(this.model) && this.model.length > 0) {
        this.filteredData = this.filteredData.filter(x => {
          return !this.model.some(b => {
            if (this.nestedObjectKey) {
              return b[this.nestedObjectKey].id == x[this.nestedObjectKey].id
            }
            return b.id == x.id
          })
        })
      }
    }
  },
  mounted() {
    const unwatch = this.$watch('modelValue', newValue => {
      if (newValue) {
        const modelValue = Array.isArray(this.modelValue) ? toRaw(this.modelValue.map(x => toRaw(x))) : toRaw(this.modelValue)
        this.originalModelValue = structuredClone(modelValue)
        unwatch()
      }
    });
  },
  data() {
    return {
      filteredData: [],
      model: null,
      placeholder: '',
      originalModelValue: []
    }
  }
}
</script>

<style scoped>
  /* Fixes possible bug with vue3 animations and buefy  */
  :deep(.dropdown-menu.fade-leave-to) {
    opacity: 1 !important;
  }
</style>
